module.exports = __webpack_public_path__ + "static/media/drive-together-icon.66285d36.svg";